import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isBefore, isAfter } from 'date-fns';

export function dateRange(minDate?: Date, maxDate?: Date): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    if (minDate) {
      if (isBefore(control.value, minDate)) {
        return {
          dateRange: { min: minDate, max: maxDate, actual: control.value },
        };
      }
    }

    if (maxDate) {
      if (isAfter(control.value, maxDate)) {
        return {
          dateRange: { min: minDate, max: maxDate, actual: control.value },
        };
      }
    }

    return null;
  };
}
